import { useEffect, useState } from "react";

const Timer = (props) => {
  const [timer, setTimer] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const deadline = props.deadline;

  useEffect(() => {
    const id = setInterval(function () {
      const endDate = deadline + 3 * 60 * 60 * 1000;
      const startDate = Date.parse(new Date().toUTCString()) + 3 * 60 * 60 * 1000;
      const difference = endDate - startDate;
      
      if(difference <= 0){
        window.location.reload();
      }

      const days = parseInt(difference / 1000 / 60 / 60 / 24);
      const hours = parseInt((difference - (days * 1000 * 60 * 60 * 24)) / 1000 / 60 / 60);
      const minutes = parseInt((difference - (days * 1000 * 60 * 60 * 24) - (hours * 1000 * 60 * 60)) / 1000 / 60);
      const seconds = parseInt((difference - (days * 1000 * 60 * 60 * 24) - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000);

      setTimer({
        days: days < 10 ? "0" + days : days,
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds
      })
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [deadline]);

  return (
    <div className="title-timer">
      <div className="title-timer__cell title-timer__cell_days">
        <span className="title-timer-value">{timer.days}</span>
        <span className="title-timer-label">дни</span>
      </div>
      <div className="title-timer__cell title-timer__cell_hours">
        <span className="title-timer-value">{timer.hours}</span>
        <span className="title-timer-label">час</span>
      </div>
      <div className="title-timer__cell title-timer__cell_mins">
        <span className="title-timer-value">{timer.minutes}</span>
        <span className="title-timer-label">мин</span>
      </div>
      <div className="title-timer__cell title-timer__cell_secs">
        <span className="title-timer-value">{timer.seconds}</span>
        <span className="title-timer-label">сек</span>
      </div>
    </div>
  );
};

export default Timer;
